import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter,withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideState, provideStore } from '@ngrx/store';
import { dataReducer, testReducer } from './ngrxstore/data.reducer';
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes,withHashLocation()), 
    provideClientHydration(withEventReplay()),
    provideStore(),  // Root store
    provideState({ name: 'data', reducer: dataReducer }),
    provideState({ name: 'test', reducer: testReducer }),
    provideHttpClient(withFetch())
    
  ]
};
